/**
 * Item grouped by:
 *      id
 *      type
 */

var CartItem = function(props) {
    var self = this;

    props = Object.assign({
        type: undefined,
        id: undefined,
        name: undefined,
        quantity: 1,
        price: undefined,
        upcharge: undefined,
        category: undefined,
        modkey: '--',
        modifiers: []
    }, props);

    // construct modkey if not set
    if (props.modifiers && props.modkey === '--') {
        var modkey = '-';
        props.modifiers.forEach(mod => modkey += `${mod.id}-`);
        modkey += '-';
        props.modkey = modkey;
    }

    // set properties
    Object.keys(props).forEach(key => self[key] = props[key]);
};

CartItem.prototype = {
    constructor: CartItem,
    type: undefined,
    id: undefined,
    name: undefined,
    quantity: undefined,
    price: undefined,
    upcharge: undefined,
    category: undefined,
    modkey: undefined,
    modifiers: undefined,
    uid: function() {
        // type_id_modkey
        return `${this.groupId()}_${this.modkey}`;
    },
    groupId: function() {
        // type_id
        return `${this.type}_${this.id}`;
    },
    export: function() {
        return {
            type: this.type,
            id: this.id,
            name: this.name,
            quantity: this.quantity,
            price: this.price,
            upcharge: this.upcharge,
            category: this.category,
            modkey: this.modkey,
            modifiers: this.modifiers
        };
    }
};

module.exports = CartItem;
